import React from 'react'
import classNames from 'classnames'
import styles from '../../../CSS/main.css'
import Popover from '../Popover'

type Props = {
  readonly open: boolean
  readonly onClose: () => void
  readonly title?: string
  readonly children: React.ReactNode
}
const RightPanel: React.FC<Props> = ({ children, open, onClose, title }) => {
  const menuClasses = classNames({
    [styles.Menu]: true,
    [styles.MenuRight]: true,
    [styles.MenuRightOpen]: open,
  })

  return (
    <Popover
      open={open}
      backdropClassNames={classNames([styles.ButtonCover, styles.CoverDark])}
      backdropStyle={{ display: 'block' }}
      keepMounted={true}
      onClose={onClose}>
      <div className={menuClasses}>
        <div
          className={classNames([
            styles.ButtonIcon,
            styles.IconClose,
            styles.MenuClose,
          ])}
          onClick={onClose}
          title='Close'
        />
        <div className={styles.Content}>
          {!!title && <div className={styles.MenuHeader}>{title}</div>}
          {children}
        </div>
      </div>
    </Popover>
  )
}

export default RightPanel
